"use client";

import Button from '@mui/material/Button';
import { useTheme, alpha } from '@mui/material/styles';
import { useSession } from "next-auth/react";
import { FunctionComponent } from "react";

const DashboardButton: FunctionComponent = () => {
  const theme = useTheme();
  const isLight = theme.palette.mode === 'light';
  const { data: session } = useSession();
  let loggedIn = false;
  if (session && session.user) {
    loggedIn = true;
  }

  return (
    <Button
      variant="outlined"
      rel="noopener"
      href="/dashboard"
      sx={{
        px: 3,
        py: 1,
        borderRadius: '8px',
        borderColor: alpha(theme.palette.text.primary, 0.3),
        color: 'text.primary',
        fontWeight: 500,
        fontSize: '0.875rem',
        textTransform: 'none',
        transition: 'all 0.2s ease',
        '&:hover': {
          borderColor: 'text.primary',
          background: alpha(theme.palette.text.primary, 0.05),
        },
      }}
    >
      Dashboard
    </Button>
  );
};

export default DashboardButton;
